<template>
  <section>
    <div class="row">
      <div class="col">
        <video
          ref="player"
          class="video-js vjs-fluid"
          :lang="$i18n.locale === 'tw' ? 'zh-tw' : $i18n.locale"
        ></video>
        <br>
        <div class="vjs-playlist"></div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'

import videojs from 'video.js'
import videojs_playlist from 'videojs-playlist'
import videojs_playlist_ui from 'videojs-playlist-ui'

import i18n from '@/plugins/i18n.js'

videojs.addLanguage('zh-TW', {
  'Now Playing': '正在播放',
  'Up Next': '播放下一個',
  'Untitled Video': '未命名視訊'
})

videojs.addLanguage('en', {
  'Now Playing': 'Playing'
})

export default {
  i18n,
  name: 'video-player',
  props: {
    videos: {
      type: Array,
      required: true,
      default: () => []
    },
    player_options: {
      type: Object,
      default: () => ({})
    },
    playlist_options: {
      type: Object,
      default: () => ({})
    },
    playlist_ui_options: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      player: null,
      player_playlist: [],
      default_player_options: {
        autoplay: false,
        preload: 'none',
        controls: true,
        responsive: true,
        controlBar: {
          skipButtons: {
            forward: 10,
            backward: 10
          }
        },
        sources: []
      },
      default_playlist_options: {
        current_item_index: -1,
        autoplay: true,
        display_ui: true
      },
      default_playlist_ui_options: {
        horizontal: true,
        language: 'zh-Hant'
      }
    }
  },
  watch: {
    videos(new_videos) {
      if (new_videos.length > 0) {
        this.$nextTick(() => {
          this.setPlayerPlaylist()
          this.setPlayer()
        })
      }
    }
  },
  methods: {
    setPlayerPlaylist() {
      this.player_playlist = []
      
      this.videos.forEach(video => {
        let playlist_item = {
          name: video.name,
          description: video.description,
          sources: [{ src: video.url, type: 'video/mp4' }],
          thumbnail: video.thumbnail || [
            {
              src: 'https://www2.budaedu.org/official-website-data/black.jpg',
              style: 'width:0.5em;height:3em;'
            }
          ]
        }

        if (video.poster) {
          playlist_item.poster = video.poster;
        }

        this.player_playlist.push(playlist_item)
      })
    },
    setPlayer() {
      if (this.player) {
        this.player.dispose()
      }

      if (this.$refs.player != undefined) {
        // 使用選項初始化播放器
        const player_options = Object.assign({}, this.default_player_options, this.player_options)
        this.player = videojs(this.$refs.player, player_options, () => { this.player.log('on_video_player_ready', this) })

        // 初始化播放器播放列表
        this.player.playlist(this.player_playlist)
        const playlist_options = Object.assign({}, this.default_playlist_options, this.playlist_options)
        if (playlist_options.current_item_index >= 0) {
          this.player.playlist.currentItem(playlist_options.current_item_index)
        }
        if (playlist_options.autoplay) {
          this.player.playlist.autoadvance(0)
        }
        if (playlist_options.display_ui) {
          const playlist_ui_options = Object.assign({}, this.default_playlist_ui_options, this.playlist_ui_options)
          this.player.playlistUi(playlist_ui_options)
        }
      }
    }
  },
  created() {
    //alert(`Vue version : ${Vue.version}`)
  },
  mounted() {
    if (this.videos.length > 0) {
      this.setPlayerPlaylist()
      this.setPlayer()
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }
}
</script>